<template>
    <div class="parking-lot-status">
        <v-checkbox
            v-if="params.data.isInParkingLot || params.isPastPromotions"
            v-model="value"
            class="rtls-checkbox"
            @update:model-value="setSelected"
        />
        <v-checkbox
            v-if="params.value === parkingLotStates.planned"
            v-model="value"
            class="rtls-checkbox"
            disabled
        />
        <icon v-if="params.value === parkingLotStates.executed" icon-name="custom:locked" small />
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import parkingLotStates from '@enums/parking-lot-states';

export default defineComponent({
    data() {
        return {
            parkingLotStates,
            value: false,
        };
    },
    mounted() {
        if (this.params.value === parkingLotStates.planned) {
            this.value = true;
            return;
        }
        this.value = this.params.node.isSelected();
        this.emitter.on('selectAllChanged', this.selectAllHandler);
    },
    beforeUnmount() {
        this.emitter.off('selectAllChanged', this.selectAllHandler);
    },
    methods: {
        setSelected(value) {
            this.params.node.setSelected(value);
        },
        selectAllHandler(param) {
            if (this.params.value === parkingLotStates.planned) return;
            this.params.node.setSelected(param);
            this.value = param;
        },
    },
});
</script>

<style lang="scss" scoped>
.parking-lot-status {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    :deep(.v-selection-control) {
        min-height: var(--v-input-control-height);
    }
}
</style>
